import { Link } from 'react-router-dom'
import { callPath } from '../../routes'

/**
 * A call's permalink: its public /r/<id> page, which anyone can open without
 * signing in. Shown as "#<id> ↗" wherever a call is listed.
 */
const CallLink = ({ id, className = '' }: { id: number; className?: string }) => (
  <Link
    to={callPath(id)}
    title="Permalink: this call's public page"
    aria-label={`Permalink to call #${id}`}
    className={`font-mono text-accent hover:underline ${className}`}
    data-testid="call-link"
  >
    #{id} <span aria-hidden="true">↗</span>
  </Link>
)

export default CallLink
